const config = {
  baseURL: window.location.origin,
  apiURL: window.__RUNTIME_CONFIG__.API_URL,
}
export default config;